export default __webpack_public_path__ + "static/clapperboard-359072b2f6eed071d9e3717f2190701a.webp";